import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions'
import * as ShipConstants from '../../Global/Constants';

const messages = (props) => {
	return (
		<div className="toast-main col-12 col-md-6 col-xl-4" style={props.dispMsg === true ? {'display':'block'} : {'display':'none'}}>
		    
				{/*
		    <div className={props.msgType === ShipConstants.SUCCESS_MSG ? 'fade toast show crm_Success animated fadeInDown' : props.msgType === ShipConstants.FAIL_MSG ? 'fade toast show crm_Error' : props.msgType === ShipConstants.WARN_MSG ? 'fade toast show crm_Warning' : props.msgType === ShipConstants.INFO_MSG ? 'fade toast show crm_Info' : 'fade toast show crm_Success'} role="alert">
		        <div className="toast-header"> <i className="fas fa-check-circle fa-lg"></i> <strong className="mr-auto pl-2">
		        {
		        	props.msgType === ShipConstants.SUCCESS_MSG ? 'Success' : 
		        		props.msgType === ShipConstants.FAIL_MSG ? 'Error' : 
		        			props.msgType === ShipConstants.WARN_MSG ? 'Warning' : 
		        				props.msgType === ShipConstants.INFO_MSG ? 'Info' : null
		        }
		        </strong>
		            <button type="button" onClick={props.clearMessage} className="close ml-2 mb-1" data-dismiss="toast"> <span aria-hidden="true">×</span><span className="sr-only">Close</span> </button>
		        </div>
		        <div className="toast-body" dangerouslySetInnerHTML={{__html: props.msg}} >
		        </div>
		    </div>
				*/}


		    <div className={props.msgType === ShipConstants.SUCCESS_MSG ? 'fade toast show crm_Success animated fadeInDown' : props.msgType === ShipConstants.FAIL_MSG ? 'fade toast show crm_Error animated fadeInDown' : props.msgType === ShipConstants.WARN_MSG ? 'fade toast show crm_Warning animated fadeInDown' : props.msgType === ShipConstants.INFO_MSG ? 'fade toast show crm_Info animated fadeInDown' : 'fade toast show crm_Success animated fadeInDown'} role="alert">

		      	<button type="button" aria-hidden="true" className="close" data-notify="dismiss" onClick={props.clearMessage}>×</button>
		      	
            <div className="d-flex align-items-start justify-content-between">
               <div className="toast-icon p-2"> 
                  <span data-notify="icon" className={props.msgType === ShipConstants.SUCCESS_MSG ? 'fas fa-check' : props.msgType === ShipConstants.FAIL_MSG ? 'fas fa-times' : props.msgType === ShipConstants.WARN_MSG ? 'fas fa-exclamation' : props.msgType === ShipConstants.INFO_MSG ? 'fas fa-info' : ''}></span> 
               </div>
               <div className="toast-body" style={{"width":'85%'}}>                            
                  <span data-notify="message"> 
                     	<span data-notify="title">
                     		{
								        	props.msgType === ShipConstants.SUCCESS_MSG ? 'Success' : 
								        	props.msgType === ShipConstants.FAIL_MSG ? 'Error' : 
								        	props.msgType === ShipConstants.WARN_MSG ? 'Warning' : 
								        	props.msgType === ShipConstants.INFO_MSG ? 'Info' : null
								        }
                     	</span>
                     	<div className="text-dark w-100">   
                        <p className="  mb-0"	title={props.msg} dangerouslySetInnerHTML={{__html: props.msg}}> 

                        </p> 
                      </div> 
                  </span>                        
               </div>
            </div>                   
         </div>

		    {/*<div className="fade toast show crm_Error" role="alert">
		        <div className="toast-header"> <i className="fas fa-times-circle fa-lg"></i> <strong className="mr-auto pl-2">Error</strong>
		            <button type="button" className="close ml-2 mb-1" data-dismiss="toast"> <span aria-hidden="true">×</span><span className="sr-only">Close</span> </button>
		        </div>
		        <div className="toast-body"> Message Content goes here .... </div>
		    </div>
		    <div className="fade toast show crm_Warning" role="alert">
		        <div className="toast-header"> <i className="fas fa-exclamation-circle fa-lg"></i> <strong className="mr-auto pl-2">Warning</strong>
		            <button type="button" className="close ml-2 mb-1" data-dismiss="toast"> <span aria-hidden="true">×</span><span className="sr-only">Close</span> </button>
		        </div>
		        <div className="toast-body"> Message Content goes here .... </div>
		    </div>
		    <div className="fade toast show crm_Info" role="alert">
		        <div className="toast-header"> <i className="fas fa-info-circle fa-lg"></i> <strong className="mr-auto pl-2">Info</strong>
		            <button type="button" className="close ml-2 mb-1" data-dismiss="toast"> <span aria-hidden="true">×</span><span className="sr-only">Close</span> </button>
		        </div>
		        <div className="toast-body"> Message Content goes here .... </div>
		    </div>*/}
		</div>
	)
}

const mapStateToProps = state => {
  return {
    dispMsg : state.commonReducer.dispMsg,
	msgType : state.commonReducer.msgType,
	msg : state.commonReducer.msg
  };
}

const mapDispatchToProps = dispatch => {
  return {
    clearMessage : () => dispatch(actions.clearMessage())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(messages);